const flag = "production"; // Change this to "production" for production environment
const env = {
  production: {
    BACKEND_URL: "https://api.maveshibids.com",
    BACKEND_STORAGE_URL: "https://api.maveshibids.com/storage",
    API_URL: "https://api.maveshibids.com/api",
    FRONTEND_URL: "https://maveshibids.com",
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
  },
  staging: {
    BACKEND_URL: "http://127.0.0.1:8000",
    BACKEND_STORAGE_URL: "http://127.0.0.1:8000/storage",
    API_URL: "http://127.0.0.1:8000/api",
    FRONTEND_URL: "https://maveshibids.com",
    GOOGLE_MAPS_API_KEY: process.env.REACT_APP_GOOGLE_MAPS_API_KEY || "",
  },
};

export default {
  ...env[flag],
  flag: flag,
};
